import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

import { IS_PRODUCTION_BUILD, NEXT_PUBLIC_BUGSNAG_API_KEY, NEXT_BUILD_ID } from './env';

export default function start() {
  // next.js executes top-level code at build time. See https://github.com/vercel/next.js/discussions/16840 for further example
  // So use NEXT_PHASE to avoid Bugsnag.start being executed during the build phase
  // See https://nextjs.org/docs/api-reference/next.config.js/introduction and https://github.com/vercel/next.js/blob/canary/packages/next/shared/lib/constants.ts#L1-L5 for
  // more details on NEXT_PHASE
  if (!IS_PRODUCTION_BUILD) {
    Bugsnag.start({
      apiKey: NEXT_PUBLIC_BUGSNAG_API_KEY,
      appVersion: NEXT_BUILD_ID,
      plugins: [
        new BugsnagPluginReact()
      ]
    })
  }
}
